(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ace-07-offer"] && !Shopify.designMode) return;
  try {
    
/* ACE · Oferta — clic en cualquier pack dispara el botón Releasit (mismo flujo COD) */
(function () {
  function fireCod() {
    /* Botón "Comprar ahora" de Releasit (id estable -> abre el formulario COD) */
    var btn = document.getElementById('rsi_buy_now_button')
      || document.querySelector('.ace-offer__cta-app [id^="rsi_"]')
      || document.querySelector('.ace-offer__cta-app [class*="rsi_animation"]');
    if (btn) { btn.click(); }
  }
  function bind() {
    var packs = document.querySelectorAll('.ace-offer__pack');
    for (var i = 0; i < packs.length; i++) {
      if (packs[i].dataset.codBound) continue;
      packs[i].dataset.codBound = '1';
      packs[i].addEventListener('click', fireCod);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sht-01-hero"] && !Shopify.designMode) return;
  try {
    
/* SHT · dispara el formulario Releasit COD desde cualquier CTA [data-sht-cod].
   Listener delegado a nivel documento: sirve para los CTAs de todas las secciones,
   estén presentes ahora o insertados después. Se registra una sola vez. */
(function () {
  if (window.__shtCodInit) return;
  window.__shtCodInit = true;

  function fireCod() {
    /* Releasit (actual) inyecta el botón con clase/id "_rsi-buy-now-button" (guiones).
       Se prueba primero dentro de nuestro contenedor, luego global y por último el
       naming legacy "rsi_buy_now_button" por si la app vuelve a cambiar. */
    var btn = document.querySelector('.sht-offer__cta-app ._rsi-buy-now-button')
      || document.querySelector('._rsi-buy-now-button-product')
      || document.querySelector('._rsi-buy-now-button')
      || document.getElementById('rsi_buy_now_button')
      || document.querySelector('[id^="rsi_buy_now"]');
    if (btn) { btn.click(); return true; }
    return false;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-sht-cod]');
    if (!t) return;
    e.preventDefault();
    if (!fireCod()) {
      var offer = document.getElementById('sht-oferta');
      if (offer) offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();

/* SHT · fija la fecha de hoy (zona horaria Colombia) en los call-outs [data-sht-today]. */
(function () {
  var nodes = document.querySelectorAll('[data-sht-today]');
  if (!nodes.length) return;
  var meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var d, m;
  try {
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Bogota', day: '2-digit', month: '2-digit', year: 'numeric' }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    d = parseInt(o.day, 10);
    m = parseInt(o.month, 10) - 1;
  } catch (e) {
    var now = new Date();
    d = now.getDate();
    m = now.getMonth();
  }
  var txt = d + ' de ' + meses[m];
  for (var i = 0; i < nodes.length; i++) nodes[i].textContent = txt;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sht-05-oferta"] && !Shopify.designMode) return;
  try {
    
/* Estimador de entrega: hoy+min / hoy+max, formato español "8 de julio".
   Se corre al año si el rango cruza el 31 de diciembre. Sin dependencias. */
(function () {
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  function addDays(date, n) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    d.setDate(d.getDate() + n);
    return d;
  }
  function fmt(d, withYear) {
    var s = d.getDate() + ' de ' + MESES[d.getMonth()];
    if (withYear) s += ' de ' + d.getFullYear();
    return s;
  }

  function fillEta() {
    var boxes = document.querySelectorAll('.sht-ship__eta');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var min = parseInt(box.getAttribute('data-days-min'), 10);
      var max = parseInt(box.getAttribute('data-days-max'), 10);
      if (isNaN(min)) min = 2;
      if (isNaN(max)) max = 4;
      var today = new Date();
      var start = addDays(today, min);
      var end = addDays(today, max);
      var withYear = start.getFullYear() !== end.getFullYear();
      var startEl = box.querySelector('.sht-ship__eta-start');
      var endEl = box.querySelector('.sht-ship__eta-end');
      if (startEl) startEl.textContent = fmt(start, withYear);
      if (endEl) endEl.textContent = fmt(end, withYear);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillEta);
  } else {
    fillEta();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sht-10-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__shtStickyInit) return;
    window.__shtStickyInit = true;

    function init() {
      var bar = document.querySelector('[data-sht-stickybar]');
      if (!bar) return;
      // Se mueve al <body> para que position:fixed no dependa de ancestros con transform.
      if (bar.parentNode !== document.body) document.body.appendChild(bar);

      var SHOW_AT = 350; // px de scroll antes de mostrarla (CTA disponible apenas se forma el interés)
      var GAP_BOTTOM = 220; // no tapar el footer / CTA final

      // Perf: no leer scrollHeight/innerHeight en cada scroll (fuerza layout).
      // Se cachean y se actualizan solo cuando el documento cambia de tamaño
      // (ResizeObserver cubre las imágenes lazy que van cargando).
      var docH = 0;
      var winH = 0;
      var ticking = false;

      function measure() {
        docH = document.documentElement.scrollHeight;
        winH = window.innerHeight;
      }

      function update() {
        ticking = false;
        var y = window.pageYOffset || 0;
        var show = y > SHOW_AT && (y + winH) <= (docH - GAP_BOTTOM);
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }

      measure();
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () { measure(); onScroll(); }).observe(document.documentElement);
      } else {
        window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
